import { Component, ViewChild } from '@angular/core';
import { TagModule } from 'primeng/tag';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { DividerModule } from 'primeng/divider';
import { NgIf } from '@angular/common';
import { ToastService } from '../../../services/toast.service';
import { ToastModule } from 'primeng/toast';
import { ZXingScannerComponent, ZXingScannerModule } from '@zxing/ngx-scanner';
import { ShipmentService } from '../../../services/shipment-service';
import { IShipment } from '../../../interfaces/IShipment';
import { QrReaderService } from '../../../services/qr-reader.service';
import { ActivatedRoute, Router } from '@angular/router';
import { QrScannerComponent } from '../../../shared/qr-scanner/qr-scanner.component';


@Component({
  selector: 'app-welcome',
  standalone: true,
  imports: [TagModule, CheckboxModule, FormsModule, ButtonModule,CardModule, NgIf, ToastModule, QrScannerComponent],
  templateUrl: './welcome.component.html',
  styleUrl: './welcome.component.scss'
})

export class WelcomeComponent {
  private readonly pendingShipmentIdKey = 'pending_shipment_id';

  constructor(private toastService: ToastService,private shipmentService: ShipmentService,
              private qrReaderService: QrReaderService, private router: Router,
              private route: ActivatedRoute) {}
  accepted:boolean = true;
  isCameraOpen:boolean = false;

  async ngOnInit() {
    await this.processShipmentIdFromLink();
  }

  async qrCodeCaptured(qrValue: string) {
    this.isCameraOpen = false;
    let result = await this.qrReaderService.qrCodeCaptured(qrValue);
    if (result) {
      this.router.navigate(['/shipment']);
    }
  }


  termsAcceptedChange(){
    if(!this.accepted){
      this.isCameraOpen =false;
    }
  }


  openQRScanner() {
    if(!this.accepted){
      this.toastService.warn('Terms and Conditions not accepted', 'Please accept the terms and conditions before scanning the QR code.', 5000);      
      return;
    }
    this.isCameraOpen = true;
  }

  private async processShipmentIdFromLink() {
    const shipmentIdParam = sessionStorage.getItem(this.pendingShipmentIdKey);

    if (!shipmentIdParam) {
      return;
    }

    const shipmentId = Number(shipmentIdParam);
    if (!Number.isFinite(shipmentId) || shipmentId <= 0) {
      sessionStorage.removeItem(this.pendingShipmentIdKey);
      return;
    }

    sessionStorage.setItem(this.pendingShipmentIdKey, shipmentId.toString());

    const result = await this.qrReaderService.qrCodeCaptured(shipmentId.toString());

    await this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { shipmentId: null },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });

    sessionStorage.removeItem(this.pendingShipmentIdKey);

    if (result) {
      await this.router.navigate(['/shipment']);
    }
  }
}
